export default {
    importSecureFile: {
        load_error: "Ошибка загрузки",
        import_ok: "Файл лицензии успешно импортирован",
        import_error: "Ошибка запроса",
    },
}